import { useLayoutEffect } from 'react'

import { useAppStore } from '../../store/appStore/appStore'

/**
 * Sets the browser tab title for routes that are not driven by CMS `ViewConfig`.
 * The store appends ` - Helo`.
 */
interface SetDocumentTitleProps {
  title: string
}

export const SetDocumentTitle = ({ title }: SetDocumentTitleProps) => {
  useLayoutEffect(() => {
    useAppStore.getState().browserDocumentTitle.updateTitle({
      staticTitle: title,
      viewLabel: null,
      detailEntityDisplay: null,
      detailDrawerSuffix: null,
    })
    return () => {
      useAppStore.getState().browserDocumentTitle.resetForNavigation()
    }
  }, [title])

  return null
}
